import { useState, useEffect } from "react";
import Loader from "../../common/loader";
import NavBar from "../../common/navbar";
import { handleAuth, postRequestOptions, getRequestOptions, baseUrl } from "../../common/cookie";
import axios from "axios";

function WithholdingTaxCheck() {
  let [error, setError] = useState<any>({});
  let [errorText, setErrorText] = useState<any>("");
  let [summary, setSummary] = useState<any>(null);

  let url: any = baseUrl + `previous-collections`;
  let [dates, setCollectionDates]: any = useState([]);
  useEffect(() => {
    fetch(url, getRequestOptions)
      .then((res) => {
        handleAuth(res.status);
        return res.json();
      })
      .then((data) => {
        setCollectionDates(data);
      });
  }, []);

  async function handleSubmit(event: any) {
    event.preventDefault();
    setRequestStatus(true);
    setSummary(null);

    let form: any = document.getElementById("withholding-tax-form");
    let formData = new FormData(form);

    try {
      setError({});
      setErrorText("");
      let url = baseUrl + "withholding-tax";
      let action: any = await axios.post(url, formData, postRequestOptions);
      handleAuth(action);
      if (action.data.error) {
        setError(action.data.error);
        setErrorText(action.data.error);
      } else {
        setSummary(action.data.summary);
        window.open(action.data.downloadUrl);
      }

      setRequestStatus(false);
    } catch (error: any) {
      console.error("Error:", error);
      setErrorText(error?.message || error?.toString() || "An error occurred");
      setRequestStatus(false);
    }
  }

  let [request, setRequestStatus] = useState(false);

  if (request) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <NavBar />
      <div className="title">
        <h1>Withholding Tax Analysis</h1>
      </div>
      <div className="card-body card row xlsx-card">
        <form onSubmit={(event) => handleSubmit(event)} encType="multipart/form-data" id="withholding-tax-form">
          <h3>Select the portfolio's date</h3>

          <select className="select-collection-date" name="collectionDate">
            {dates.map((date: any, index: any) => (
              <option key={index} value={date}>
                {date}
              </option>
            ))}
          </select>

          <h2>Upload Nomura Cash Activity File</h2>
          <p>Upload the Nomura Prime CSV file to identify withholding tax deductions on coupon payments</p>

          <div className="drop-container">
            <input multiple={false} className="drop-box-input" placeholder="Upload or drop file" type="file" name="file" accept=".xlsx, .csv" required />
          </div>

          <div className="form-check mt-3 mb-3">
            <input className="form-check-input" type="checkbox" name="updatePortfolio" id="updatePortfolio" value="true" />
            <label className="form-check-label" htmlFor="updatePortfolio">
              <strong>Update Portfolio Tax Rates</strong> - Save detected withholding tax rates to portfolio positions
            </label>
          </div>

          <h4 className="error-text">{errorText ? errorText : ""}</h4>

          <button type="submit" className="btn upload-btn">
            Analyze
          </button>
        </form>

        {summary && (
          <div>
            <h3>Analysis Summary</h3>
            <table className="table table-striped table-light table-hover">
              <tbody>
                <tr>
                  <td>Securities with Tax Withheld</td>
                  <td><strong>{summary.securitiesWithTax}</strong></td>
                </tr>
                <tr>
                  <td>Total Gross Coupons</td>
                  <td><strong>${summary.totalGrossCoupons?.toLocaleString()}</strong></td>
                </tr>
                <tr>
                  <td>Total Tax Withheld</td>
                  <td><strong className="text-danger">${summary.totalTaxWithheld?.toLocaleString()}</strong></td>
                </tr>
                <tr>
                  <td>Total Net Received</td>
                  <td><strong className="text-success">${summary.totalNetReceived?.toLocaleString()}</strong></td>
                </tr>
                <tr>
                  <td>Items Requiring Review</td>
                  <td><strong className={summary.itemsRequiringReview > 0 ? "text-warning" : "text-success"}>{summary.itemsRequiringReview}</strong></td>
                </tr>
                <tr>
                  <td>Skipped Records (Treasuries, Cancel/Correct)</td>
                  <td><strong>{summary.skippedCount || 0}</strong></td>
                </tr>
                {summary.taxRatesSaved > 0 && (
                  <tr>
                    <td>Tax Rates Saved to Reference Table</td>
                    <td><strong className="text-primary">{summary.taxRatesSaved}</strong></td>
                  </tr>
                )}
                {(summary.portfolioUpdated > 0 || summary.portfolioNotInPortfolio > 0 || summary.portfolioUpdateFailed > 0) && (
                  <>
                    <tr>
                      <td>Portfolio Positions Updated</td>
                      <td><strong className="text-success">{summary.portfolioUpdated || 0}</strong></td>
                    </tr>
                    {summary.portfolioNotInPortfolio > 0 && (
                      <tr>
                        <td>Positions Not In Portfolio (Closed)</td>
                        <td><strong className="text-secondary">{summary.portfolioNotInPortfolio}</strong></td>
                      </tr>
                    )}
                    {summary.portfolioUpdateFailed > 0 && (
                      <tr>
                        <td>Portfolio Update Failed</td>
                        <td><strong className="text-danger">{summary.portfolioUpdateFailed}</strong></td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <h4 className="error-text">{error && Object.keys(error).length > 0 ? JSON.stringify(error) : ""}</h4>
    </div>
  );
}

export default WithholdingTaxCheck;
